import styled from "styled-components";

export const Container = styled.div`
    position: absolute;
    top: ${64 * 1.5}px;
`;

export const Button = styled.button`
    background-color: white;
    padding: 0;
    width: 64px;
    height: 64px;
    margin-top: -32px;
    margin-left: -32px;
    box-shadow: 0 0 0 3px black inset;
    border-radius: 32px;
    font-size: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    cursor: pointer;
    user-select: none;
    border: none;
    outline: none;
    font-weight: 600;
    transition: transform 300ms, background-color 300ms, color 300ms;

    &:active {
        transform: scale(1.1);
        background-color: ${p => p.theme.c.active};
        color: white;
    }

    &.Small {
        font-size: 22px;
    }

    &.Seed {
        width: 20px;
        height: 20px;
        margin-top: -10px;
        margin-left: -10px;
        pointer-events: none;
        background-color: black;
    }
`;

export const SvgCanvas = styled.svg`
    position: absolute;
    width: ${4 * 64}px;
    height: ${4 * 64}px;
    top: -128px;
    left: -128px;
`;
